var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-checkbox",class:[
  _vm.getChecked && 'data-checkbox_checked',
  _vm.disabled && 'disabled',
  !_vm.nochange && 'pointer',
  !_vm.nochange && 'hover'
],on:{"click":_vm.toggleCheck}},[_c('transition',[_c('TJIcon',{staticClass:"data-checkbox__icon",class:_vm.getChecked && 'data-checkbox__icon_show',attrs:{"name":_vm.getIconName ? _vm.getIconName : '',"size":16}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }